import React, {useEffect} from 'react';
import QRCode from 'react-qr-code';
import { Modal } from '../../../../../components';
import styles from './Modals.module.css';

function useCopyModal(commands) {
  const copyTextToClipboard = async (text) => {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    }
    return document.execCommand('copy', true, text);
  };

  const closeModal = () => commands.closeModal();

  return ({
    eventHandlers: {
      closeModal,
      copyTextToClipboard,
    },
    localStates: {

    },
  });
}

export default function CopyModal(props) {
  const {
    commands, sharedStates, metaStates, remoteStates,
  } = props;
  const { localStates, eventHandlers } = useCopyModal(commands);

  const loadingPix = Object.values(metaStates).some((item) => item === true);
  
  
  useEffect(() => {
    if (!loadingPix && sharedStates.visible) { eventHandlers.copyTextToClipboard(remoteStates.pix.code); }
  }, [loadingPix, sharedStates.visible]);

  return (
    <Modal
      sharedStates={sharedStates}
      commands={commands}
    >
      <div className={styles.container}>
        { !loadingPix
          ? (
            <>
              <h2 className={styles.title}>Código copiado!</h2>
              <div className={styles.instructionsBox}>
                { ['Abra o seu aplicativo do banco',
                  'Utilize a opção Pix copia e cola',
                  'Cole o código Pix',
                  'Finalize o pagamento']
                  .map((item, index) => <p key={index} className={styles.instruction}>{`${index + 1}. ${item}`}</p>)}
              </div>
            </>
          )
          : <h2 className={styles.title}>Gerando PIX...</h2>}
      </div>
    </Modal>
  );
}
